/**
 * Gets the combined percentage of a book for a list of documents
 *
 * @method getPercentageOfBookForDocuments
 * @param {Array<BookDocument>} documents - an array of BookDocument objects
 * @return {Number} a percentage of the book from 0 to 1
 */
const getPercentageOfBookForDocuments = (documents) => {
  documents = [...new Set(documents)]; // ensure all unique

  return Math.min(
    documents.reduce((percentage, document) => {
      return (percentage += document.percentage);
    }, 0),
    1,
  );
};

export default getPercentageOfBookForDocuments;
